
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M12.306 9.065a.5.5 0 00-.737.337.5.5 0 00.037.308 4.062 4.062 0 01-.1 3.624 2.89 2.89 0 01-.858-1 .498.498 0 00-.121-.166.499.499 0 00-.383-.127.499.499 0 00-.196.062 3.547 3.547 0 00-1.924 3.215 3.978 3.978 0 107.955 0 7.334 7.334 0 00-3.673-6.253v0z","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M1.14 2.5a.5.5 0 00-.485.621l.75 3a.5.5 0 00.485.379h.61v15h3v-15h13v15h3v-15h.61a.5.5 0 00.485-.379l.75-3a.5.5 0 00-.091-.429.5.5 0 00-.394-.192H1.14zm4.36 19h13m-16-15h3.501M2.5 9.5h3m-3 3h3m-3 3h3m-3 3h3m13-9h3m-3 3h3m-3 3h3m-3 3h3m-3-12h3","stroke":"#50657c","stroke-linecap":"round","stroke-linejoin":"round"}})])
          )
        }
      }
    